import { createI18n } from 'vue-i18n'

import defaultEn from './en/default.js'
import gdprEn from './en/gdpr.js'
import defaultFr from './fr/default.js'
import gdprFr from './fr/gdpr.js'

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    en: {
      ...defaultEn,
      gdpr: gdprEn,
    },
    fr: {
      ...defaultFr,
      gdpr: gdprFr,
    },
  },
})
